export async function GET_CATEGORY ({commit}, defaultFullAccess = null) {
  const {data} = await this.$frontendRepositories.users.getCategory();

  commit('setCategories', data.data.map(item => ({
    ...item,
    full_access: defaultFullAccess,
  })));
}

export function SET_FULL_ACCESS_BY_CATEGORY ({commit}, payload) {
  commit('setFullAccessByCategory', payload);
}

export function CHECK_ALL_CATEGORIES ({commit}) {
  commit('bulkSetFullAccess', true);
}

export function UN_CHECK_ALL_CATEGORIES ({commit}) {
  commit('bulkSetFullAccess', null);
}